var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActiveFavorites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00033 17.0418C8.74199 17.0418 8.49199 17.0085 8.28366 16.9335C5.10033 15.8418 0.0419922 11.9668 0.0419922 6.24183C0.0419922 3.32516 2.40033 0.958496 5.30033 0.958496C6.70866 0.958496 8.02533 1.5085 9.00033 2.49183C9.97533 1.5085 11.292 0.958496 12.7003 0.958496C15.6003 0.958496 17.9587 3.3335 17.9587 6.24183C17.9587 11.9752 12.9003 15.8418 9.71699 16.9335C9.50866 17.0085 9.25866 17.0418 9.00033 17.0418Z",
    fill: "#D80000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveFavorites);
export default __webpack_public_path__ + "static/media/activeFavorites.133a6515fd606477d7ac853a740a6cd8.svg";
export { ForwardRef as ReactComponent };